import type { UserEnrichedInfoResponse } from '@/types'

export const USER_ROLES = {
  owner: 'owner',
  admin: 'admin',
  member: 'member',
  editor: 'editor',
  advanced: 'advanced',
  multi: 'multi',
  partnerOwner: 'partner_owner',
  partnerMember: 'partner_member',
  developer: 'developer',
  other: 'other',
  sso_admin: 'sso_admin',
  sso_editor: 'sso_editor',
  superuser: 'superuser',
} as const

export const baseUserRoles = [
  USER_ROLES.owner,
  USER_ROLES.admin,
  USER_ROLES.member,
] as const

export enum UserStatuses {
  inactive = 'inactive',
  active = 'active',
  invited = 'invited',
  disabled = 'disabled',
  InviteExpired = 'expired',
}

export const USER_ENRICHED_INFO = {
  clearbit_enriched: false,
  linkedin_profile: null,
  title: null,
  employee_range: null,
} as UserEnrichedInfoResponse
